import { render, staticRenderFns } from "./PuzzleArchive.vue?vue&type=template&id=962c6816"
import script from "./PuzzleArchive.vue?vue&type=script&lang=js"
export * from "./PuzzleArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports